import Vue from 'vue'
import App from './index.vue'
// 引入reset.css
import "@/assets/pingxuan2020/pc/css/reset.css"
import VueLazyLoad from 'vue-lazyload'
Vue.use(VueLazyLoad, {
  loading: ''				// 替换需要的图片
})
// require('@/assets/pingxuan2020/pc/images/lazyy.png')	
Vue.config.productionTip = false
// 引入防抖插件
import throttle from 'lodash/throttle'
Vue.prototype.$navSelect = (type) => {
  if (type === "年度黑科技") {
    return "黑科技";
  } else if (type === "年度游戏设备") {
    return "游戏设备";
  }else if (type === "年度酷装备") {
		return "酷装备";
	}else if (type === "年度新能源车") {
		return "新能源车";
	} else {
    return type;
  }
}
// Vue.prototype._ = _
new Vue({
  throttle,
  render: h => h(App),
}).$mount('#app')
